import { gql } from "config/graphql";
import { IUser } from "config/types";
import { gqlQuery } from "store/apollo";

interface IFetchNotificationsResponse {
  data: {
    me: IUser;
  };
}

export const fetchCurrentUserNotifications = (): Promise<IFetchNotificationsResponse> => {
  const query = gql`
    query userNotifications {
      me {
        notifications {
          id
          metadata
        }
      }
    }
  `;

  return gqlQuery<IFetchNotificationsResponse["data"]>({
    query,
  });
};

export const accountNotificationsQuery = (): Promise<IFetchNotificationsResponse> => {
  const query = gql`
    query AccountNotifications {
      me {
        activeConstellations {
          activeInsuranceMembership {
            notifications {
              id
              read
              metadata
            }
          }
        }
      }
    }
  `;

  return gqlQuery<IFetchNotificationsResponse["data"]>({
    query,
  });
};
